// extracted by css-extract-rspack-plugin
export default {"tagsSection":"TagsSection-module__tagsSection__eAUR5","categories":"TagsSection-module__categories__YrLuy"};